import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

import BackLink from '../BackLink'
import Contact from '../Contact'
import DataSharing from '../DataSharing'
import DonationExtras from '../DonationExtras'
import EmployerMatchingStatus from '../EmployerMatchingStatus'
import PageHeader from '../PageHeader'
import useContactValidation from '../useContactValidation'

const ContactStep = ({
  i18n, donation, plugins,
  session, collect_phone, collect_address, data_sharing,
  beneficiary, partner, partner_is_pledge, foundation, defaultShares,
  extras, blank_modal_src, emoji_picker_loader_src, widget_instance_token,
  employerMatching, onBack, onContinue,
}) => {
  const { validation, validate } = useContactValidation({
    i18n, donation, session, collect_phone,
  })

  // Flatten error arrays to first-message strings for InputField props.
  const errors = Object.fromEntries(
    Object.entries(validation.errors).map(([ k, v ]) => [ k, v?.[0] ])
  )

  const handleSubmit = async e => {
    e.preventDefault()
    // Run both validations regardless so all errors surface in one pass,
    // then bail if either failed.
    const contactValid = await validate()
    const pluginsValid = plugins.validateSlots([ 'afterDataSharing' ], { donation })
    if (!contactValid || !pluginsValid) return
    onContinue()
  }

  return (
    <form onSubmit={handleSubmit} noValidate className="space-y-4">
      <PageHeader heading={i18n.t('steps.contact.heading')} />
      <Contact
        i18n={i18n}
        donation={donation}
        errors={errors}
        resetError={validation.resetErrorsFor}
        collect_phone={collect_phone}
        session={session}
      />

      <div className="space-y-2">
        <DataSharing
          i18n={i18n}
          foundation={foundation}
          partner_is_pledge={partner_is_pledge}
          data_sharing={data_sharing}
          collect_address={collect_address}
          collect_phone={collect_phone}
          beneficiary={beneficiary}
          partner={partner}
          defaultShares={defaultShares}
          shares={donation.shares}
          setShares={donation.setShares}
        />
        <EmployerMatchingStatus
          i18n={i18n}
          employerMatching={employerMatching}
          shares={donation.shares}
        />
        {plugins.renderSlot('afterDataSharing', { donation })}
        <DonationExtras
          extras={extras}
          i18n={i18n}
          blank_modal_src={blank_modal_src}
          emoji_picker_loader_src={emoji_picker_loader_src}
          widget_instance_token={widget_instance_token}
        />
      </div>

      <div className="space-y-2">
        <button
          type="submit"
          className="btn btn-primary flex w-full items-center justify-center gap-2"
        >
          {i18n.t('continue')}
          <FontAwesomeIcon icon={faArrowRight} className="rtl:-scale-x-100" />
        </button>
        <BackLink i18n={i18n} onClick={onBack} />
      </div>
    </form>
  )
}

export default ContactStep
